import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {ProjectsService} from '../../../services/projects.service';
import {MatTableDataSource} from '@angular/material/table';
import {ProjectsData} from '../all-projects/projects.component';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderTitleService} from '../../../services/general/header-title.service';
import {ModalSurveyDetailsComponent} from '../../../modals/modal-survey-details/modal-survey-details.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {AiService} from '../../../services/ai.service';
import {forEach} from 'lodash';
import {BackendService} from '../../../services/general/backend.service';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {filter} from 'rxjs/operators';
import {ProjectPropertiesService} from "../../../services/project-properties.service";
import {GradeService} from '../../../services/grade.service';
import {GradeRevision, GradeDocument, GradeTable, CreateRevisionFromSearchRequest, CreateGradeDocumentRequest, CreateGradeRevisionRequest, GradeQuality} from '../../../models/grade.models';
import {Subscription} from 'rxjs';
import {ModalAddAttachmentComponent} from '../../../modals/modal-add-attachment/modal-add-attachment.component';
import {CsvExportService} from '../../../services/general/csv-export.service';
import {ModalEditDocumentComponent, EditDocumentDialogData, EditDocumentDialogResult} from '../../../modals/modal-edit-document/modal-edit-document.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {ToastService} from '../../../services/general/toast.service';

// Using GradeTable from grade.models.ts

export class JsonTableService {
  parseJsonData(jsonString: string): GradeTable[] {
    try {
      // Rimuove l'intestazione della tabella e parsa il JSON
      const jsonContent = jsonString.split('\n\n')[1];
      return JSON.parse(jsonContent) as GradeTable[];
    } catch (error) {
      console.error('Errore nel parsing JSON:', error);
      return [];
    }
  }
}

@Component({
    selector: 'app-project-detail',
    templateUrl: './project-detail.component.html',
    styleUrls: ['./project-detail.component.scss'],
    standalone: false
})
export class ProjectDetailComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort) biblioSearchSort!: MatSort;
  @ViewChild(MatPaginator) biblioPaginator!: MatPaginator;

  constructor(
    public userService: UserService,
    private projectService: ProjectsService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private headerTitleService: HeaderTitleService,
    private router: Router,
    private translateService: TranslateService,
    private aiService: AiService,
    private backend: BackendService,
    private projectPropertiesService: ProjectPropertiesService,
    private gradeService: GradeService,
    private csvExportService: CsvExportService,
    private toast: ToastService
  ) {
    this.biblioSearchDataSource = new MatTableDataSource<GradeTable>([]);
  }

  keywords: string = '';
  keywordsForChipList: string[] = [];
  biblioTable: object | null = null;
  question = '';

  // Chip input configuration
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  projectProperties: Array<object> = null;


  // patients: string = 'Pazienti anziani con diabete di tipo 2';
  // intervention: string = 'Una dieta a basso contenuto di carboidrati';
  // comparison: string = 'Rispetto alla dieta standard';
  // outcomes: string = 'Migliorare il controllo glicemico';
  // studies: string = 'Trial clinici randomizzati (RCT) e studi interventistici controllati';
  // timeframe: string = 'A medio-lungo termine (da 3 a 12 mesi)';

  // patients: string = "Pazienti adulti con ipertensione";
  // intervention: string = "Assunzione di farmaci anti-ipertensivi";
  // comparison: string = "Cambiamento dello stile di vita (dieta e attività fisica)";
  // outcomes: string = "Riduzione della pressione arteriosa";
  // studies: string = "Trial clinici randomizzati (RCT) e studi di coorte";
  // timeframe: string = "Minimo 6 mesi di follow-up";

  // patients: string = 'Lattanti (età < 12 mesi) con diagnosi di bronchiolite acuta moderata';
  // intervention: string = 'Nebulizzazione con soluzione salina ipertonica (al 3%)';
  // comparison: string = 'Nebulizzazione con soluzione salina normale (isotonica, allo 0.9%) o nessuna nebulizzazione (terapia di supporto standard)';
  // outcomes: string = 'Riduzione della durata del ricovero ospedaliero e miglioramento dei punteggi di gravità clinica(es.score respiratorio)';
  // studies: string = 'Trial clinici randomizzati (RCT) in doppio cieco e revisioni sistematiche (Cochrane)';
  // timeframe: string = 'Dalla valutazione in pronto soccorso fino a 7 giorni (o alla dimissione)';

  patients: string = '';
  intervention: string = '';
  comparison: string = '';
  outcomes: string = '';
  studies: string = '';
  timeframe: string = '';

  loading = false;
  project_id = null;
  project = null;
  projectFieldUpdatable = ['title', 'description', 'obiettivi', 'contesto_clinico_scientifico', 'faculty', 'board', 'propertyOptions'];
  projectUpdateModel = {
    title: '',
    description: '',
    obiettivi: '',
    contesto_clinico_scientifico: '',
    faculty: '',
    board: '',
    propertyOptions: {},
  };

  picoQuestionStatus: string | null = null;
  biblioSearchStatus: string | null = null;
  biblioSearchDisplayedColumns: string[] = [
    'authors',
    'year',
    'articleTitle',
    'studyType',
    'mainOutcome',
    'precision',
    'consistency',
    'riskOfBias',
    'gradeQuality',
    'remove',
  ];
  biblioSearchDataSource: MatTableDataSource<GradeTable>;

  pubmedResults: any = {};
  pubmedResultsCached: any = {};

  searchNumItems = null;

  processStatus$ = this.aiService.processStatus$;
  isProcessing = false;
  currentProcessId: number | null = null;

  // Track single document processing state
  isProcessingSingleDocument = false;

  // Enhanced grade management
  gradeRevisions: GradeRevision[] = [];
  currentGradeRevision: GradeRevision | null = null;

  // Store PICO components for post-AI-completion update
  private pendingPicoComponents: any = null;

  // Track when backend is handling grade revision creation
  private backendHandlingGradeRevision = false;

  // Track processed process IDs to prevent duplicate document saving
  private processedProcessIds = new Set<number>();

  private subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.project_id = params.project_id;
      this.init();

      // Load existing grade revisions for this project after project_id is set
      this.loadProjectGradeRevisions();

      // Check literature review attachments status
      this.checkLiteratureAttachments();
    });

    // Enhanced AI process status handling with debugging
    this.aiService.processStatus$.subscribe((process) => {


      if (process?.status === 'completed' && process?.result !== null) {

        // Prevent duplicate processing of the same process ID
        if (process.id && this.processedProcessIds.has(process.id)) {
          return;
        }

        // Mark this process as processed
        if (process.id) {
          this.processedProcessIds.add(process.id);
        }

        try {
          let parsedResponse: any = null;

          // NEW FORMAT: Check if data is directly available in process.result.tabella
          if (process.result.tabella && Array.isArray(process.result.tabella)) {
            // Use the tabella array directly - skip all the JSON parsing
            parsedResponse = { tabella: process.result.tabella };
            } else {

              // Use the same robust JSON parsing as in PICO generation
              let jsonString = process.result.response
                .replace(/```json/gi, '') // Remove markdown code blocks
                .replace(/```/g, '') // Remove remaining backticks
                .replace(/^"json\s*/, '') // Remove leading "json
                .replace(/`/g, '') // Remove any remaining backticks
                .replace(/^\n+/, '') // Remove leading newlines
                .replace(/\n+$/, '') // Remove trailing newlines
                .trim();

              // Try to find JSON content between braces if needed
              const jsonMatch = jsonString.match(/\{[\s\S]*\}/);
              if (jsonMatch) {
                jsonString = jsonMatch[0];
              }

              // Check if JSON appears to be truncated (common signs)
              const seemsTruncated =
                !jsonString.endsWith('}') || // Doesn't end with closing brace
                !jsonString.endsWith('}]') || // Doesn't end with array closing
                jsonString.includes('"authors"') && !jsonString.match(/"authors":\s*"[^"]*"[^}]*}[^}]*}\s*$/) || // Incomplete last object
                jsonString.match(/"[^"]*$/) || // Ends with incomplete string
                jsonString.match(/,$\s*$/) || // Ends with trailing comma
                (jsonString.match(/\{/g) || []).length > (jsonString.match(/\}/g) || []).length; // More opens than closes

              if (seemsTruncated) {
                // Try to close incomplete objects/arrays gracefully
                jsonString = this.repairTruncatedJson(jsonString);
              }

              try {
                parsedResponse = JSON.parse(jsonString);
              } catch (parseError) {

              // Advanced JSON repair attempts
              let fixedJson = jsonString;

              // Step 1: Fix common structural issues
              fixedJson = fixedJson
                .replace(/,\s*]/g, ']')  // Remove trailing commas before ]
                .replace(/,\s*}/g, '}') // Remove trailing commas before }
                .replace(/\n/g, ' ')    // Remove newlines
                .replace(/\r/g, ' ')    // Remove carriage returns
                .replace(/\t/g, ' ')    // Remove tabs
                .replace(/\s+/g, ' ')   // Normalize whitespace
                .trim();

              // Step 2: Fix specific malformed patterns common in AI responses

              // Fix the specific issue: missing commas between properties
              // Pattern: "property":"value""nextProperty" -> "property":"value","nextProperty"
              fixedJson = fixedJson.replace(/"([^"]*)"(\s*"[^"]*"\s*:)/g, '"$1",$2');

              // Fix: "property":value"nextProperty" -> "property":value,"nextProperty"
              fixedJson = fixedJson.replace(/([^,\s])"([^"]*"\s*:)/g, '$1,"$2');

              // Fix missing commas before objects: }"property" -> },"property"
              fixedJson = fixedJson.replace(/\}(\s*"[^"]*"\s*:)/g, '},$1');

              // Fix missing commas after objects: }{ -> },{
              fixedJson = fixedJson.replace(/\}\s*\{/g, '},{');

              // Step 3: Try to find and fix incomplete objects/arrays
              if (fixedJson.indexOf('{') !== -1) {
                // Count braces to see if JSON is incomplete
                const openBraces = (fixedJson.match(/\{/g) || []).length;
                const closeBraces = (fixedJson.match(/\}/g) || []).length;
                const openBrackets = (fixedJson.match(/\[/g) || []).length;
                const closeBrackets = (fixedJson.match(/\]/g) || []).length;

                // Add missing closing braces/brackets
                for (let i = 0; i < (openBraces - closeBraces); i++) {
                  fixedJson += '}';
                }
                for (let i = 0; i < (openBrackets - closeBrackets); i++) {
                  fixedJson += ']';
                }

                  // Step 3: Fix truncation and incomplete strings
                fixedJson = this.repairTruncatedJson(fixedJson);

                // Fix incomplete strings at the end
                if (fixedJson.match(/:\s*"[^"]*$/)) {
                  fixedJson = fixedJson.replace(/:\s*"[^"]*$/, ': ""');
                }

                // Fix strings that contain unescaped JSON structural characters
                // This prevents strings like "},\n    {" from breaking the parsing
                fixedJson = fixedJson.replace(/"([^"]*[{}\[\]][^"]*)"/g, (match, content) => {
                  // If the content contains JSON structural chars, clean it
                  if (content.includes('{') || content.includes('}') || content.includes('[') || content.includes(']')) {
                    const cleaned = content
                      .replace(/[{}\[\]]/g, '') // Remove JSON structural characters
                      .replace(/\s*,\s*/g, ', ') // Normalize comma spacing
                      .replace(/\s+/g, ' ')     // Normalize whitespace
                      .trim();
                    return `"${cleaned}"`;
                  }
                  return match;
                });

                // Fix strings that are just structural JSON elements
                fixedJson = fixedJson.replace(/"[\s,}]+"/g, '""'); // Replace strings that are just whitespace and JSON punctuation
                fixedJson = fixedJson.replace(/"},[\s\n]*\{"/g, '"", ""'); // Fix malformed object separators in strings
              }

              try {
                parsedResponse = JSON.parse(fixedJson);

              } catch (secondError) {


                // Step 4: Last resort - try emergency extraction but with better data handling

                try {
                  // Try to extract whatever structured data we can find
                  parsedResponse = this.extractDataFromMalformedJson(jsonString);

                  if (parsedResponse && parsedResponse.length > 0) {

                  } else {
                    throw new Error('No data extracted');
                  }
                } catch (emergencyError) {
                  this.loading = false;
                  this.biblioSearchStatus = null;
                  this.showErrorToast('AI response parsing completely failed. Please try the literature review again or contact support.');
                  return;
                }
              }
            }
          } // Close the OLD FORMAT else block

          // Validate that we got a valid parsed response
          if (!parsedResponse) {
            this.loading = false;
            this.biblioSearchStatus = null;
            this.showErrorToast('Failed to parse AI response. Please try again.');
            return;
          }

          // Process and transform the data for display and storage
          let processedData = [];

          // Try multiple data structure patterns
          if (parsedResponse.tabella && Array.isArray(parsedResponse.tabella)) {
            processedData = parsedResponse.tabella.map((item: any, index: number) =>
              this.transformAIResultToGradeTable(item)
            );
          } else if (parsedResponse.articles && Array.isArray(parsedResponse.articles)) {
            processedData = parsedResponse.articles.map((item: any, index: number) =>
              this.transformAIResultToGradeTable(item)
            );
          } else if (parsedResponse.results && Array.isArray(parsedResponse.results)) {
            processedData = parsedResponse.results.map((item: any, index: number) =>
              this.transformAIResultToGradeTable(item)
            );
          } else if (Array.isArray(parsedResponse)) {
            processedData = parsedResponse.map((item: any, index: number) =>
              this.transformAIResultToGradeTable(item)
            );
          } else {
            this.loading = false;
            this.biblioSearchStatus = null;
            this.showErrorToast('AI response has unexpected structure. Please try again.');
            return;
          }

          // Update the data source with processed data
          this.biblioSearchDataSource.data = processedData;
          this.biblioSearchDataSource.sort = this.biblioSearchSort;
          this.biblioSearchStatus = null;
          this.loading = false; // Clear loading spinner

          // Check if backend indicates data was processed and stored
          const backendProcessedData = process.result.total_articles ||
                                      process.result.processed_at ||
                                      process.result.bedrock_process_id;

          // Reset backend handling flag immediately to prevent duplicate processing
          const wasBackendHandling = this.backendHandlingGradeRevision;
          this.backendHandlingGradeRevision = false;

          // Always refresh grade revisions since we now auto-save all searches to project
          setTimeout(() => {
            this.loadProjectGradeRevisions();
          }, 1000);


          if (process.result.grade_revision_id) {
            // Update the grade revision with PICO components if we have pending data
            if (this.pendingPicoComponents) {
              this.updateGradeRevisionWithPicoComponents(process.result.grade_revision_id);
            }
          } else {
            console.error('CRITICAL: No grade_revision_id found in process result!');
          }
        } catch (error) {
          console.error(' Error processing completed result:', error);
          this.loading = false;
          this.biblioSearchStatus = null;
          // Reset flag in case of error
          this.backendHandlingGradeRevision = false;
        }
      } else if (process?.status === 'failed') {
        this.biblioSearchStatus = null;
        this.loading = false;
        // Reset flag in case of failure
        this.backendHandlingGradeRevision = false;
      } else if (
        process?.status === 'pending' ||
        process?.status === 'processing'
      ) {
      }
    });

    // Note: We don't subscribe to gradeRevisions$ here because it starts with empty array
    // and would immediately clear any loaded data. We handle updates through direct loading.
  }

  ngOnDestroy() {
    this.aiService.stopPolling();
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Shows a toast notification message
   */
  private showToast(message: string, action: string = 'Close', duration: number = 4000): void {
    this.snackBar.open(message, action, {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  /**
   * Shows a success toast notification
   */
  private showSuccessToast(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['success-snackbar']
    });
  }

  /**
   * Shows an error toast notification
   */
  private showErrorToast(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['error-snackbar']
    });
  }

  /**
   * Transforms AI response format to the expected GradeTable format
   */
  private transformAIResultToGradeTable(aiResult: any): GradeTable {
      // Enhanced DOI and PMID extraction with multiple fallbacks
    const doi = aiResult.doi || aiResult.DOI || aiResult.Doid || aiResult.doid || '';
    const pmid = aiResult.pmid || aiResult.PMID || aiResult.PubMedId || aiResult.pubmedId || '';
    let link = aiResult.link || aiResult.url || '';

    // Auto-generate link if we have DOI or PMID but no direct link
    if (!link) {
      if (doi) {
        link = this.generateDoiLink(doi) || '';
      } else if (pmid) {
        link = this.generatePubMedLink(pmid) || '';
      }
    }

    // Create the final transformed object with proper fallbacks
    const transformed = {
      authors: aiResult.authors || aiResult.author || 'Authors not specified',
      year: this.parseYear(aiResult.year),
      articleTitle: aiResult.articleTitle || aiResult.title || 'Title not available',
      studyType: aiResult.studyType || aiResult.study_type || 'Study type not specified',
      mainOutcome: aiResult.mainOutcome || aiResult.main_outcome || 'Outcome not specified',
      precision: this.mapGradeQualityFromAI(aiResult.precision),
      consistency: this.mapGradeQualityFromAI(aiResult.consistency),
      riskOfBias: this.mapRiskOfBiasFromAI(aiResult.riskOfBias),
      gradeQuality: this.mapGradeQualityFromAI(aiResult.gradeQuality),
      doi: doi,
      pmid: pmid,
      pdf_file_path: aiResult.pdf_file_path || '',
      link: link
    };

    return transformed;
  }

  /**
   * Parses year from AI response (could be string or number)
   */
  private parseYear(year: any): number {
    if (typeof year === 'number') return year;
    if (typeof year === 'string') {
      const parsed = parseInt(year, 10);
      return isNaN(parsed) ? new Date().getFullYear() : parsed;
    }
    return new Date().getFullYear();
  }

  /**
   * Maps AI grade quality descriptions to database enum values
   * Enhanced to handle more variations and complex descriptions
   */
  private mapGradeQualityFromAI(aiValue: string): string {
    if (!aiValue) return 'moderate';

    const normalized = aiValue.toLowerCase().trim();

    // Handle complex Italian descriptions with explanations
    if (
      normalized.includes('molto bassa') ||
      normalized.includes('very low') ||
      normalized.includes('very_low') ||
      (normalized.includes('bassa') &&
        normalized.includes('campione') &&
        normalized.includes('piccolo'))
    ) {
      return 'very_low';
    }

    if (
      normalized.includes('bassa') ||
      normalized.includes('low') ||
      normalized.includes('limitata') ||
      normalized.includes('scarsa')
    ) {
      return 'low';
    }

    if (
      normalized.includes('alta') ||
      normalized.includes('high') ||
      (normalized.includes('ampio') && normalized.includes('campione')) ||
      normalized.includes('elevata') ||
      normalized.includes('buona')
    ) {
      return 'high';
    }

    if (
      normalized.includes('moderata') ||
      normalized.includes('moderate') ||
      normalized.includes('media') ||
      normalized.includes('intermedia')
    ) {
      return 'moderate';
    }

    // Extract parenthetical information for additional context
    const parenthetical = normalized.match(/\(([^)]+)\)/);
    if (parenthetical) {
      const context = parenthetical[1];

      if (
        context.includes('ampio') ||
        context.includes('grande') ||
        context.includes('elevato')
      ) {
        return 'high';
      }
      if (
        context.includes('piccolo') ||
        context.includes('limitato') ||
        context.includes('scarso')
      ) {
        return 'low';
      }
    }

    return 'not assessed';
  }

  /**
   * Maps AI risk of bias descriptions to database enum values
   * Enhanced to handle more variations and complex descriptions
   */
  private mapRiskOfBiasFromAI(aiValue: string): string {
    if (!aiValue) return 'moderate';

    const normalized = aiValue.toLowerCase().trim();

    // Handle complex Italian descriptions
    if (normalized.includes('molto alto') ||
        normalized.includes('very high') ||
        normalized.includes('very_high') ||
        normalized.includes('elevato') ||
        (normalized.includes('alto') && (normalized.includes('molto') || normalized.includes('grave')))) {
      return 'very_high';
    }

    if (normalized.includes('alto') ||
        normalized.includes('high') ||
        normalized.includes('significativo') ||
        normalized.includes('importante')) {
      return 'high';
    }

    if (normalized.includes('basso') ||
        normalized.includes('low') ||
        normalized.includes('minimo') ||
        normalized.includes('ridotto') ||
        normalized.includes('limitato')) {
      return 'low';
    }

    if (normalized.includes('moderato') ||
        normalized.includes('moderate') ||
        normalized.includes('medio') ||
        normalized.includes('intermedio')) {
      return 'moderate';
    }

    // Check for methodological terms that indicate bias level
    if (normalized.includes('randomizzato') && normalized.includes('controllato')) {
      return 'low';
    }
    if (normalized.includes('osservazionale') || normalized.includes('retrospettivo')) {
      return 'moderate';
    }

    return 'not assessed';
  }

  /**
   * Extracts data from severely malformed JSON by parsing individual objects
   */
  private extractDataFromMalformedJson(jsonString: string): any {

    const results: any[] = [];

    // Look for individual objects that match the expected pattern
    const objectPatterns = [
      // Try to find complete objects with all expected fields including DOI/PMID
      /\{\s*"authors":\s*"([^"]*)"[^}]*"year":\s*(\d+)[^}]*"articleTitle":\s*"([^"]*)"[^}]*"studyType":\s*"([^"]*)"[^}]*"mainOutcome":\s*"([^"]*)"[^}]*"precision":\s*"([^"]*)"[^}]*"consistency":\s*"([^"]*)"[^}]*"riskOfBias":\s*"([^"]*)"[^}]*"gradeQuality":\s*"([^"]*)"[^}]*(?:"doi":\s*"([^"]*)"[^}]*)?(?:"pmid":\s*"([^"]*)"[^}]*)?[^}]*\}/g,

      // Try to find partial objects and complete them
      /\{\s*"authors":\s*"([^"]*)"[^}]*"year":\s*(\d+)[^}]*"articleTitle":\s*"([^"]*)"[^}]*(?:"doi":\s*"([^"]*)"[^}]*)?(?:"pmid":\s*"([^"]*)"[^}]*)*/g
    ];

    let extractedCount = 0;

    for (const pattern of objectPatterns) {
      let match;
      pattern.lastIndex = 0; // Reset regex state

      while ((match = pattern.exec(jsonString)) !== null && extractedCount < 20) {
        try {
          if (match.length >= 11) {
            // Complete object found with DOI/PMID
            const result = {
              authors: match[1] || '',
              year: parseInt(match[2]) || new Date().getFullYear(),
              articleTitle: match[3] || 'Unknown Title',
              studyType: match[4] || 'Unknown Study Type',
              mainOutcome: match[5] || 'Unknown Outcome',
              precision: match[6] || 'Moderate',
              consistency: match[7] || 'Moderate',
              riskOfBias: match[8] || 'Moderate',
              gradeQuality: match[9] || 'Moderate',
              doi: match[10] || '',
              pmid: match[11] || ''
            };
            results.push(result);
            extractedCount++;

          } else if (match.length >= 9) {
            // Complete object found without DOI/PMID
            const result = {
              authors: match[1] || '',
              year: parseInt(match[2]) || new Date().getFullYear(),
              articleTitle: match[3] || 'Unknown Title',
              studyType: match[4] || 'Unknown Study Type',
              mainOutcome: match[5] || 'Unknown Outcome',
              precision: match[6] || 'Moderate',
              consistency: match[7] || 'Moderate',
              riskOfBias: match[8] || 'Moderate',
              gradeQuality: match[9] || 'Moderate',
              doi: '',
              pmid: ''
            };
            results.push(result);
            extractedCount++;
          } else if (match.length >= 4) {
            // Partial object - fill in missing fields with defaults
            const result = {
              authors: match[1] || '',
              year: parseInt(match[2]) || new Date().getFullYear(),
              articleTitle: match[3] || 'Unknown Title',
              studyType: 'Unknown Study Type',
              mainOutcome: 'Unknown Outcome',
              precision: 'Moderate',
              consistency: 'Moderate',
              riskOfBias: 'Moderate',
              gradeQuality: 'Moderate',
              doi: match[4] || '',
              pmid: match[5] || ''
            };
            results.push(result);
            extractedCount++;

          }
        } catch (extractError) {
          console.warn('Error extracting individual object:', extractError);
          continue;
        }
      }

      if (extractedCount > 0) {
        break; // Stop if we found some results with the first pattern
      }
    }

    // If still no results, try to extract any text that looks like article data
    if (extractedCount === 0) {

      // Look for quoted strings that might be titles, but with better filtering
      const titlePattern = /"([^"]{30,200})"/g;
      let titleMatch;
      let titleIndex = 0;

      while ((titleMatch = titlePattern.exec(jsonString)) !== null && titleIndex < 10) {
        const title = titleMatch[1].trim();

        // Skip if it looks like JSON structural elements, field names, or malformed content
        const isInvalidTitle =
          title.match(/^(authors|year|articleTitle|studyType|mainOutcome|precision|consistency|riskOfBias|gradeQuality)$/i) ||
          title.includes('},{') || // JSON object separators
          title.includes('},') ||  // JSON ending fragments
          title.includes('{') ||   // JSON opening braces
          title.includes('}') ||   // JSON closing braces
          title.includes('\n') ||  // Newlines (likely structural)
          title.match(/^[\s,}]+$/) || // Only whitespace and JSON punctuation
          title.match(/^(high|low|moderate|very.?low|alta|bassa|moderata|molto.?bassa)$/i) || // Grade values
          title.length < 30 ||     // Too short to be a real article title
          title.match(/^\d{4}$/) || // Just a year
          title.match(/^Authors \d+$/) || // Generated author names
          title.match(/^(Unknown|Extracted|Error)/) || // Our placeholder values
          title.includes('original_legacy_data') || // Internal JSON field names
          title.includes('search_timestamp'); // Internal JSON field names

        if (!isInvalidTitle) {

          // Do a final sanity check - does this look like a real article title?
          const seemsLikeArticleTitle =
            title.length >= 30 &&
            title.match(/[a-zA-Z]/) && // Contains letters
            !title.match(/^[\d\s\-_,.:;]+$/) && // Not just numbers and punctuation
            (title.includes(' ') || title.includes('-')); // Has word separators

          if (seemsLikeArticleTitle) {
            // Try to find real author data and identifiers near this title instead of generating fake names
            const realAuthors = this.extractRealAuthorsNearTitle(jsonString, title);
            const realYear = this.extractRealYearNearTitle(jsonString, title);
            const realDoi = this.extractRealDoiNearTitle(jsonString, title);
            const realPmid = this.extractRealPmidNearTitle(jsonString, title);

            results.push({
              authors: realAuthors || `Authors ${titleIndex + 1}`, // Only use fake name as absolute fallback
              year: realYear || new Date().getFullYear(),
              articleTitle: title,
              studyType: 'Extracted Study',
              mainOutcome: 'Unknown Outcome',
              precision: 'Moderate',
              consistency: 'Moderate',
              riskOfBias: 'Moderate',
              gradeQuality: 'Moderate',
              doi: realDoi || '',
              pmid: realPmid || ''
            });
            titleIndex++;

          }
        } else {
          console.log('Skipped invalid title:', title.substring(0, 30) + '...');
        }
      }

      extractedCount = titleIndex;
    }


    if (extractedCount === 0) {
      // Create at least one dummy entry so the process can continue
      results.push({
        authors: 'AI Extraction Failed',
        year: new Date().getFullYear(),
        articleTitle: 'Data could not be extracted from AI response',
        studyType: 'Error',
        mainOutcome: 'Parsing failed',
        precision: 'Very Low',
        consistency: 'Very Low',
        riskOfBias: 'Very High',
        gradeQuality: 'Very Low'
      });
    }

    return {
      tabella: results
    };
  }

  /**
   * Try to extract real author data near a given title in malformed JSON
   */
  private extractRealAuthorsNearTitle(jsonString: string, title: string): string | null {
    // Look for authors field near this title
    const titleIndex = jsonString.indexOf(title);
    if (titleIndex === -1) return null;

    // Search in a window around the title (500 chars before and after)
    const searchStart = Math.max(0, titleIndex - 500);
    const searchEnd = Math.min(jsonString.length, titleIndex + 500);
    const searchWindow = jsonString.substring(searchStart, searchEnd);

    // Look for authors field patterns
    const authorPatterns = [
      /"authors":\s*"([^"]+)"/i,
      /'authors':\s*'([^']+)'/i,
      /authors.*?:\s*["']([^"']+)["']/i
    ];

    for (const pattern of authorPatterns) {
      const match = searchWindow.match(pattern);
      if (match && match[1]) {
        const authors = match[1].trim();
        // Validate that this looks like real author data
        if (authors &&
            authors.length > 3 &&
            !authors.match(/^Authors \d+$/) &&
            (authors.includes(' ') || authors.includes('.') || authors.includes(',')) &&
            authors.match(/[a-zA-Z]/)) {
          return authors;
        }
      }
    }

    return null;
  }

  /**
   * Try to extract real year data near a given title in malformed JSON
   */
  private extractRealYearNearTitle(jsonString: string, title: string): number | null {
    // Look for year field near this title
    const titleIndex = jsonString.indexOf(title);
    if (titleIndex === -1) return null;

    // Search in a window around the title
    const searchStart = Math.max(0, titleIndex - 300);
    const searchEnd = Math.min(jsonString.length, titleIndex + 300);
    const searchWindow = jsonString.substring(searchStart, searchEnd);

    // Look for year field patterns
    const yearPatterns = [
      /"year":\s*"?(\d{4})"?/i,
      /'year':\s*'?(\d{4})'?/i,
      /year.*?:\s*["']?(\d{4})["']?/i
    ];

    for (const pattern of yearPatterns) {
      const match = searchWindow.match(pattern);
      if (match && match[1]) {
        const year = parseInt(match[1]);
        // Validate year range
        if (year >= 1990 && year <= new Date().getFullYear() + 2) {
          return year;
        }
      }
    }

    return null;
  }

  /**
   * Try to extract real DOI data near a given title in malformed JSON
   */
  private extractRealDoiNearTitle(jsonString: string, title: string): string | null {
    // Look for DOI field near this title
    const titleIndex = jsonString.indexOf(title);
    if (titleIndex === -1) return null;

    // Search in a window around the title
    const searchStart = Math.max(0, titleIndex - 500);
    const searchEnd = Math.min(jsonString.length, titleIndex + 500);
    const searchWindow = jsonString.substring(searchStart, searchEnd);

    // Look for DOI field patterns
    const doiPatterns = [
      /"doi":\s*"([^"]+)"/i,
      /'doi':\s*'([^']+)'/i,
      /doi.*?:\s*["']([^"']+)["']/i,
      /"Doid":\s*"([^"]+)"/i,
      /'Doid':\s*'([^']+)'/i,
      /Doid.*?:\s*["']([^"']+)["']/i
    ];

    for (const pattern of doiPatterns) {
      const match = searchWindow.match(pattern);
      if (match && match[1]) {
        const doi = match[1].trim();
        // Basic DOI validation
        if (doi.length > 3 && (doi.startsWith('10.') || doi.includes('/'))) {
          return doi;
        }
      }
    }

    return null;
  }

  /**
   * Try to extract real PMID data near a given title in malformed JSON
   */
  private extractRealPmidNearTitle(jsonString: string, title: string): string | null {
    // Look for PMID field near this title
    const titleIndex = jsonString.indexOf(title);
    if (titleIndex === -1) return null;

    // Search in a window around the title
    const searchStart = Math.max(0, titleIndex - 500);
    const searchEnd = Math.min(jsonString.length, titleIndex + 500);
    const searchWindow = jsonString.substring(searchStart, searchEnd);

    // Look for PMID field patterns
    const pmidPatterns = [
      /"pmid":\s*"([^"]+)"/i,
      /'pmid':\s*'([^']+)'/i,
      /pmid.*?:\s*["']([^"']+)["']/i,
      /"PMID":\s*"([^"]+)"/i,
      /'PMID':\s*'([^']+)'/i,
      /PMID.*?:\s*["']([^"']+)["']/i
    ];

    for (const pattern of pmidPatterns) {
      const match = searchWindow.match(pattern);
      if (match && match[1]) {
        const pmid = match[1].trim();
        // Basic PMID validation - should be numeric and reasonable length
        if (pmid.match(/^\d{6,8}$/)) {
          return pmid;
        }
      }
    }

    return null;
  }

  /**
   * Repairs truncated JSON by completing incomplete objects and arrays
   */
  private repairTruncatedJson(jsonString: string): string {

    let repaired = jsonString;

    // Enhanced handling for various truncation patterns

    // Pattern 1: Incomplete string value at the end (like "mainOutcome": "Espressione di lncRNA in pazienti...)
    if (repaired.match(/"[^"]*":\s*"[^"]*$/)) {
      // Complete the string and add missing object fields if needed
      repaired = repaired.replace(/"([^"]*)":\s*"([^"]*$)/, '"$1": "$2"');

      // If this appears to be a mainOutcome field and we're missing other required fields, add them
      if (repaired.includes('"mainOutcome"') && !repaired.includes('"precision"')) {
        repaired += ',\n      "precision": "Non valutabile (dati insufficienti)",\n      "consistency": "Non valutabile (dati insufficienti)",\n      "riskOfBias": "Non valutabile (dati insufficienti)",\n      "gradeQuality": "Molto bassa"';
      }
    }

    // Pattern 2: Incomplete field name at the end
    if (repaired.match(/,\s*"[^"]*$/)) {
      // Remove the incomplete field
      repaired = repaired.replace(/,\s*"[^"]*$/, '');
    }

    // Pattern 3: Handle incomplete strings (like "Murray Le" at the end)
    repaired = repaired.replace(/"([^"]*[^"\}\]\,])$/, '"$1"');

    // Pattern 4: Handle incomplete author strings specifically (common truncation point)
    if (repaired.match(/"authors":\s*"[^"]*$/)) {
      repaired = repaired.replace(/"authors":\s*"([^"]*$)/, '"authors": "$1 et al."');
    }

    // Handle incomplete objects - if we're in the middle of an object, close it
    // Look for pattern: { "field": "value", "field2": "incomplete
    if (repaired.match(/\{[^}]*"[^"]*:"/)) {
      // Find the last complete field-value pair
      const lastCompletePattern = /,\s*"([^"]+)":\s*"([^"]*)"/g;
      let lastMatch;
      let match;
      while ((match = lastCompletePattern.exec(repaired)) !== null) {
        lastMatch = match;
      }

      if (lastMatch) {
        const lastIndex = lastMatch.index + lastMatch[0].length;
        // If there's incomplete content after the last complete field, clean it up
        const remaining = repaired.substring(lastIndex);
        if (remaining && !remaining.match(/^\s*[}\]]/)) {
          // Remove incomplete trailing content and close the object
          repaired = repaired.substring(0, lastIndex) + '\n    }';
        }
      }
    }

    // Ensure proper array and object closing
    const openBraces = (repaired.match(/\{/g) || []).length;
    const closeBraces = (repaired.match(/\}/g) || []).length;
    const openBrackets = (repaired.match(/\[/g) || []).length;
    const closeBrackets = (repaired.match(/\]/g) || []).length;

    // Add missing closing braces for objects
    for (let i = 0; i < (openBraces - closeBraces); i++) {
      repaired += '\n  }';
    }

    // Add missing closing brackets for arrays
    for (let i = 0; i < (openBrackets - closeBrackets); i++) {
      repaired += '\n]';
    }

    // Clean up any trailing commas before closing braces/brackets
    repaired = repaired.replace(/,\s*([\}\]])/g, '$1');

    // Final structure validation - ensure we have the tabella array structure
    if (repaired.includes('"tabella"') && !repaired.match(/"tabella"\s*:\s*\[/)) {
      repaired = repaired.replace(/"tabella"\s*:/, '"tabella": [');
      if (!repaired.includes(']')) {
        repaired += '\n]';
      }
    }


    return repaired;
  }


  public init() {
    this.getProject();
  }

  /**
   * Check literature review attachments status
   */
  checkLiteratureAttachments(): void {
    if (!this.project_id) {
      console.warn('No project ID available for literature check');
      return;
    }


    this.aiService.checkLiteratureStatus(
      this.project_id,
      (statusResponse: any) => {

        // You can store the results or display them in the UI
        const processedRecords = statusResponse.records || [];

        // Optionally, you can emit an event or update a property
        // that the UI can use to show the status
      },
      (error: any) => {
        console.error('Failed to check literature status:', error);
      }
    );
  }

  public getProject() {
    this.loading = true;
    this.projectService.getProject(
      this.project_id,
      (result) => {
        this.project = result;
        this.project.propertyOptions = {};
        result?.project_property_options?.forEach((option) => {
          this.project.propertyOptions[option.project_property_id] = option.id;
        });

        // Se il progetto appartiene a un'altra organizzazione rispetto a quella
        // corrente dell'utente, allineiamo l'organizzazione corrente a quella del
        // progetto (solo se l'utente ne fa effettivamente parte) così menu, permessi
        // e lingua restano coerenti con ciò che si sta visualizzando.
        this.switchToProjectOrganizationIfNeeded(result.organization_id);

        this.headerTitleService.setTitle(
          this.translateService.instant('generic.table') + ': ' + result.title
        );
        this.setUpdateProjectModel();
        this.loading = false;
        this.fetchProjectProperties(this.project.organization_id);
      },
      () => {
        // Progetto non trovato o accesso negato (es. hospital di un'org "simulator"
        // a cui l'utente non è stato invitato): non ha senso restare su una pagina vuota.
        this.loading = false;
        this.router.navigate(['/projects']);
      }
    );
  }

  /**
   * Se il progetto aperto appartiene a un'organizzazione diversa da quella corrente
   * dell'utente, cambia l'organizzazione corrente con quella del progetto — ma solo
   * se l'utente fa effettivamente parte di quell'organizzazione.
   */
  private switchToProjectOrganizationIfNeeded(projectOrganizationId: any): void {
    if (!projectOrganizationId) return;
    if (this.userService.currentOrganization?.id == projectOrganizationId) return;

    const projectOrganization = this.userService.getOrganizationByID(projectOrganizationId);
    if (!projectOrganization) return;

    this.userService.setPreferredOrganization(projectOrganizationId);
    this.userService.resetCurrentLanguage();

    this.toast.success(
      this.translateService.instant('generic.success'),
      this.translateService.instant('pages.projects.project-detail.switched-organization', { name: projectOrganization.name })
    );
  }

  fetchProjectProperties(organizationId: string): void {
    this.loading = true;
    this.projectPropertiesService.getProjectPropertiesList(
      organizationId,
      (data: any) => {
        this.projectProperties = data;
        this.loading = false;
      },
      (error: any) => {
        this.loading = false;
      }
    );
  }

  generatePICOQuestion(page: number = 1) {
    this.picoQuestionStatus = 'pending';

    // Check if PICO has changed and create new revision
    const picoChanged = this.hasPicoChanged();

    const data = {
      organization_id: this.project.organization_id,
      picoStructure: {
        patients: this.patients,
        intervention: this.intervention,
        comparison: this.comparison,
        outcomes: this.outcomes,
        studies: this.studies,
        timeframe: this.timeframe,
      },
    };

    this.aiService.generatePICOResponse(
      data,
      (result) => {
        this.loading = false;

        if (result) {
          // Clean and extract JSON from AI response
          let jsonString = result.response
            .replace(/```json/gi, '') // Remove markdown code blocks
            .replace(/```/g, '') // Remove remaining backticks
            .replace(/^"json\s*/, '') // Remove leading "json
            .replace(/`/g, '') // Remove any remaining backticks
            .trim();

          // Try to find JSON content between braces if needed
          const jsonMatch = jsonString.match(/\{[\s\S]*\}/);
          if (jsonMatch) {
            jsonString = jsonMatch[0];
          }

          try {
            const jsonObject = JSON.parse(jsonString);
            // Handle keywords for both string (search) and array (chips) usage
            if (Array.isArray(jsonObject.keywords)) {
              this.keywordsForChipList = jsonObject.keywords;
              this.keywords = jsonObject.keywords.join(', ');
            } else {
              const keywordString = jsonObject.keywords?.toString() || '';
              this.keywords = keywordString;
              this.keywordsForChipList = keywordString
                ? keywordString.split(', ').map((k) => k.trim())
                : [];
            }
            this.question = jsonObject.question;
          } catch (parseError) {
            console.error('Failed to parse AI response as JSON:', parseError);
            console.error('Raw response:', result.response);
            console.error('Cleaned string:', jsonString);
            // Fallback - try to extract question and keywords manually if possible
            this.question = result.response;
            this.keywords = '';
            this.keywordsForChipList = [];
          }

          // If PICO changed, we'll create the revision later when AI processing completes
          // No need to create immediate PICO Analysis row
          if (picoChanged) {
            // this.handlePicoQuestionChange(); // DISABLED - we'll create single row later
          }
        }
        this.picoQuestionStatus = null;
      },
      (error) => {
        console.log(error);
        this.picoQuestionStatus = null;
      }
    );
  }

  public setUpdateProjectModel(reverse = false) {
    if (!reverse) {
      this.projectUpdateModel = { ...this.project };
      // const description = this.projectUpdateModel.description;

      // const data = {
      //   organization_id: this.project.organization_id,
      //   statement: description,
      // };

      // this.aiService.generateKeywordsResponse(data, (result) => {
      //   this.loading = false;
      //   this.keywords = result.response;
      //
      // });
    } else {
      for (const field of this.projectFieldUpdatable) {
        this.project[field] = this.projectUpdateModel[field];
      }
    }
  }

  public get projectUpdateModelIsChanged() {
    for (const field of this.projectFieldUpdatable) {
      if (this.projectUpdateModel[field] !== this.project[field]) {
        return true;
      }
    }
    return false;
  }

  public updateProject() {
    this.loading = true;

    const model = this.projectFieldUpdatable.reduce((acc, field) => {
      acc[field] = this.projectUpdateModel[field];
      return acc;
    }, {});

    this.projectService.updateProject(
      this.project_id,
      model,
      (result) => {
        this.setUpdateProjectModel(true);
        this.headerTitleService.setTitle('Project: ' + result.title);
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  retryProcess() {
    if (this.currentProcessId) {
      this.searchTermInPublmedEnhanced(true);
    }
  }

  // Enhanced Grade Management Methods

  trackByRevisionId(index: number, revision: GradeRevision): number {
    return revision.id;
  }

  private filterAndRenameGradeAnalysis(
    revisions: GradeRevision[]
  ): GradeRevision[] {

    // Show ALL grade revisions - not just ones with "Grade Analysis" in title
    // This includes AI-created ones like "AI Literature Review - 1/9/2025"
    const gradeAnalysisRevisions = revisions.filter((revision) => {
      const title = revision.title?.toLowerCase() || '';
      const isGradeRevision =
        title.includes('grade') ||
        title.includes('analysis') ||
        title.includes('ai literature review') ||
        title.includes('literature review') ||
        title.includes('pico');

      return isGradeRevision;
    });


    // If no revisions match the filter, show all revisions as a fallback
    if (gradeAnalysisRevisions.length === 0 && revisions.length > 0) {
      return revisions.map((revision) => ({
        ...revision,
        title: revision.title || 'Untitled Revision'
      }));
    }


    // Rename each Grade Analysis revision with the format: "grade analysis generated by $pico_question and the $keywords"
    const renamedRevisions = gradeAnalysisRevisions.map((revision) => {
      const originalTitle = revision.title;

      // Enhanced PICO question extraction with better fallbacks
      let picoQuestion = revision.search_query || revision.pico_question;

      // If still empty, try to extract from current form data as fallback
      if (!picoQuestion || picoQuestion.trim() === '') {
        picoQuestion = this.question ||
          `P: ${this.patients || ''} I: ${this.intervention || ''} C: ${this.comparison || ''} O: ${this.outcomes || ''}`.trim();
      }

      // Final fallback
      if (!picoQuestion || picoQuestion.trim() === '') {
        picoQuestion = 'PICO question not specified';
      }

      // Enhanced keywords extraction with better fallbacks
      let keywords = revision.keywords;

      // If still empty, try current form data as fallback
      if (!keywords || keywords.trim() === '') {
        keywords = this.keywords?.toString() || '';
      }

      // Final fallback
      if (!keywords || keywords.trim() === '') {
        keywords = 'Keywords not specified';
      }

      // Count documents for this revision
      const documentCount = revision.documents?.length || 0;

      // Create the new format with document count
      const displayTitle = `Grade analysis generated by the following PICO question and keywords: ${picoQuestion} \nKeywords: ${this.keywordsForChipList} \n(${documentCount} documents found)`;



      return {
        ...revision,
        title: displayTitle,
        original_title: originalTitle, // Keep track of original for debugging
      };
    });

    return renamedRevisions;
  }

  loadRevisionDocuments(revision: GradeRevision): void {


    // Set as current grade revision for FAB functionality
    this.currentGradeRevision = revision;

    // Populate textboxes with data from selected revision
    this.populateTextboxesFromRevision(revision);

    // If revision already has documents, use them directly
    if (revision.documents && revision.documents.length > 0) {
      this.populateTableWithDocuments(revision.documents);
      return;
    }

    this.loading = true;

    // Load documents for this specific revision via API
    const documentsSubscription = this.gradeService
      .getDocuments({
        grade_revision_id: revision.id,
      })
      .subscribe({
        next: (documents) => {
          this.populateTableWithDocuments(documents);
          this.loading = false;
        },
        error: (error) => {
          console.error('Error loading documents:', error);
          console.error('Error status:', error.status);
          console.error('Error message:', error.message);
          console.error('Full error object:', error);
          this.loading = false;

          // Clear the table on error
          this.biblioSearchDataSource.data = [];
        },
      });

    this.subscriptions.push(documentsSubscription);
  }

  private populateTableWithDocuments(documents: GradeDocument[]): void {

    if (documents.length === 0) {

      this.biblioSearchDataSource.data = [];

      return;
    }


    // Convert GradeDocument[] to LegacyGradeTable[]
    const legacyTableData = documents.map((doc) => {
      const converted = this.convertGradeDocumentToLegacyTable(doc);

      return converted;
    });


    // Populate the biblioSearchDataSource
    this.biblioSearchDataSource.data = legacyTableData;
    if (this.biblioSearchSort) {
      this.biblioSearchDataSource.sort = this.biblioSearchSort;
    }

    // Force change detection to ensure table updates
    this.biblioSearchDataSource._updateChangeSubscription();
  }

  private convertGradeDocumentToLegacyTable(
    document: GradeDocument
  ): GradeTable {
    // Try to extract additional information from additional_data if main fields are empty
    const docInfo = document.additional_data?.document_info;
    const originalData = document.additional_data?.original_attachment_data;

    // Extract URL for link generation with priority order
    let documentUrl: string | undefined;

    // Priority 1: Specific document info URL
    if (docInfo?.url) {
      documentUrl = docInfo.url;
    }
    // Priority 2: Generate from DOI if available
    else if (document.doi) {
      documentUrl = this.generateDoiLink(document.doi);
    }
    // Priority 3: Generate from PMID if available
    else if (document.pmid) {
      documentUrl = this.generatePubMedLink(document.pmid);
    }
    // Priority 4: Use pre-generated link from additional_data
    else if (document.additional_data?.link) {
      documentUrl = document.additional_data.link;
    }
    // Priority 5: Generate search link as fallback
    else {
      const mockResult = {
        articleTitle: document.title || '',
        authors: document.authors || '',
        doi: document.doi,
        pmid: document.pmid,
        link: undefined
      } as GradeTable;
      documentUrl = this.generateDocumentLink(mockResult);
    }

    return {
      id: document.id, // Include document ID for deletion
      authors: document.authors || originalData?.Authors || 'Unknown Authors',
      year: document.year || originalData?.PubYear || new Date().getFullYear(),
      articleTitle: document.title || docInfo?.title || originalData?.ArticleTitle || 'Untitled Document',
      studyType: document.study_type || 'Not specified',
      mainOutcome: document.main_outcome || 'Not analyzed',
      precision: this.convertGradeQualityToString(document.precision) || 'Not assessed',
      consistency: this.convertGradeQualityToString(document.consistency) || 'Not assessed',
      riskOfBias: document.risk_of_bias || 'Not assessed',
      gradeQuality: this.convertGradeQualityToString(document.grade_quality) || 'Not assessed',

      // Include link information with enhanced fallbacks
      doi: document.doi || originalData?.Doid || originalData?.DOI || document.additional_data?.doi,
      pmid: document.pmid || originalData?.PMID || document.additional_data?.pmid,
      pdf_file_path: document.pdf_file_path || document.additional_data?.pdf_file_path,
      link: documentUrl
    };
  }

  private generatePubMedLink(pmid?: string): string | undefined {
    if (!pmid) return undefined;

    // Clean and validate PMID
    const cleanPmid = pmid.toString().trim();
    if (!cleanPmid || cleanPmid === 'undefined' || cleanPmid === 'null') {
      console.warn(' Invalid PMID value:', pmid);
      return undefined;
    }

    // Remove any common prefixes/suffixes that might be invalid
    const numericPmid = cleanPmid.replace(/^(pmid:|PMID:)/i, '').replace(/[^\d]/g, '');
    if (!numericPmid || numericPmid.length < 6) {
      console.warn('PMID too short or invalid after cleaning:', cleanPmid, '->', numericPmid);
      return undefined;
    }

    return `https://pubmed.ncbi.nlm.nih.gov/${numericPmid}/`;
  }

  private generateDoiLink(doi?: string): string | undefined {
    if (!doi) return undefined;

    // Clean and validate DOI
    const cleanDoi = doi.toString().trim();
    if (!cleanDoi || cleanDoi === 'undefined' || cleanDoi === 'null') {
      console.warn('Invalid DOI value:', doi);
      return undefined;
    }

    // Remove common prefixes if present
    let processedDoi = cleanDoi.replace(/^(doi:|DOI:)/i, '').replace(/^https?:\/\/(dx\.)?doi\.org\//i, '');

    // Basic DOI format validation (should start with 10.)
    if (!processedDoi.startsWith('10.')) {
      console.warn(' DOI does not start with 10.:', processedDoi);
      return undefined;
    }

    return `https://doi.org/${processedDoi}`;
  }

  /**
   * Generates a link for a document, trying multiple strategies
   */
  private generateDocumentLink(result: GradeTable): string | undefined {
    // Priority order: DOI, PubMed, Google Scholar search

    // 1. Try DOI first
    if (result.doi) {
      return this.generateDoiLink(result.doi);
    }

    // 2. Try PubMed ID
    if (result.pmid) {
      return this.generatePubMedLink(result.pmid);
    }

    // 3. Try direct link if provided
    if (result.link) {
      return result.link;
    }

    // 4. Generate PubMed search link as primary fallback (prioritize for bibliography)
    if (result.articleTitle) {
      // Create a comprehensive search query for better PubMed matching
      let query = result.articleTitle;
      if (result.authors) {
        // Add author information to improve search accuracy
        query += ` ${result.authors}`;
      }
      if (result.year && result.year !== new Date().getFullYear()) {
        // Add year if it's not the current year (likely real publication year)
        query += ` ${result.year}`;
      }

      const pubmedSearchUrl = `https://pubmed.ncbi.nlm.nih.gov/?term=${encodeURIComponent(query)}`;
      return pubmedSearchUrl;
    }

    // 5. Generate Google Scholar search link as final fallback
    if (result.articleTitle && result.authors) {
      const query = encodeURIComponent(`"${result.articleTitle}" ${result.authors}`);
      const scholarUrl = `https://scholar.google.com/scholar?q=${query}`;
      return scholarUrl;
    }

    return undefined;
  }

  private convertGradeQualityToString(quality?: string): string {
    if (!quality) return '';
    // Convert snake_case to readable format
    return quality.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
  }

  private saveSearchResultsToDatabase(
    results: GradeTable[],
    gradeRevisionId: number
  ): void {
    if (!results || results.length === 0) {
      console.log(' No results to save');
      return;
    }

    // results.forEach((result, index) => {
    //   console.log(`Result ${index + 1}:`, {
    //     authors: result.authors,
    //     authors_type: typeof result.authors,
    //     authors_length: result.authors?.length,
    //     articleTitle: result.articleTitle?.substring(0, 50) + '...',
    //     hasAuthors: !!result.authors,
    //     authorsValue: JSON.stringify(result.authors)
    //   });
    // });

    // Filter out invalid/malformed results before saving to database
    const validResults = results.filter(result => this.isValidGradeTableResult(result));


    if (validResults.length === 0) {
      console.error(' All AI results were invalid - cannot save to database');
      this.showErrorToast('AI Literature Review completed but all results were invalid. Please try again.');
      return;
    }

    // Convert each valid result to GradeDocument format and save (original working approach)
    const savePromises = validResults.map(async (result, index) => {
      const documentRequest: CreateGradeDocumentRequest = {
        grade_revision_id: gradeRevisionId,
        title: result.articleTitle || '',
        authors: result.authors || '',
        year: result.year || new Date().getFullYear(),
        journal: '', // Not available in LegacyGradeTable
        doi: result.doi || '', // Now available in enhanced GradeTable
        pmid: result.pmid || '', // Now available in enhanced GradeTable
        abstract: '', // Not available in GradeTable
        study_type: result.studyType || '',
        main_outcome: result.mainOutcome || '',
        precision: this.convertGradeQualityFromString(
          result.precision
        ) as GradeQuality,
        consistency: this.convertGradeQualityFromString(
          result.consistency
        ) as GradeQuality,
        risk_of_bias: this.convertRiskOfBias(result.riskOfBias),
        grade_quality: this.convertGradeQualityFromString(
          result.gradeQuality
        ) as GradeQuality,
        source_type: 'search',
        additional_data: {
          original_legacy_data: result,
          search_timestamp: new Date().toISOString(),
          link: this.generateDocumentLink(result), // Generate link for the document
          // Preserve identifiers for future link generation
          doi: result.doi,
          pmid: result.pmid,
        },
      };

      return new Promise<void>((resolve, reject) => {
        this.gradeService.createDocument(documentRequest).subscribe({
          next: (savedDocument) => {
            console.log(
              ` Document ${index + 1} saved with ID:`,
              savedDocument.id,
              'for revision:', savedDocument.grade_revision_id
            );
            resolve();
          },
          error: (error) => {
            console.error(` Error saving document ${index + 1}:`, error);
            console.error(` Failed document request:`, documentRequest);
            reject(error);
          },
        });
      });
    });

    // Wait for all documents to be saved
    Promise.all(savePromises)
      .then(() => {

        // First refresh the revisions list to show updated document count
        this.loadProjectGradeRevisions();

        // If this is the currently selected revision, refresh the table immediately
        if (this.currentGradeRevision && this.currentGradeRevision.id === gradeRevisionId) {

          // Clear the table first to show we're refreshing
          this.biblioSearchDataSource.data = [];

          // Refresh table with data from database
          setTimeout(() => {
            this.refreshTableFromDatabase(gradeRevisionId);
          }, 1000);
        }
        // } else {
        //   console.log(' Saved to different revision than currently selected - only refreshing revisions list');
        // }
      })
      .catch((error) => {
        console.error(' Some documents failed to save:', error);

        // Still refresh to show any successfully saved documents
        this.loadProjectGradeRevisions();

        // Still try to refresh current table if it matches
        if (this.currentGradeRevision && this.currentGradeRevision.id === gradeRevisionId) {
          setTimeout(() => {
            this.refreshTableFromDatabase(gradeRevisionId);
          }, 2000);
        }
      });
  }

  /**
   * Validates that a GradeTable result is valid and safe to save to database
   */
  private isValidGradeTableResult(result: GradeTable): boolean {
    // Check required fields with detailed debugging
    if (!result.articleTitle || !result.authors) {
      return false;
    }

    // Check for malformed title (likely from failed JSON extraction)
    const title = result.articleTitle.toString().trim();
    const invalidTitlePatterns = [
      /^[\s,}\[\]{}]+$/, // Only JSON structural characters and whitespace
      /^Authors \d+$/, // Generated author names used as titles
      /^(Unknown|Extracted|Error)/, // Our placeholder values
      /},{.*{/, // JSON fragments
      /^\}.*\{$/, // JSON structural elements
      /\n.*\{/, // Newlines with JSON structure
    ];

    const hasInvalidTitle = invalidTitlePatterns.some(pattern => pattern.test(title));
    if (hasInvalidTitle) {
      return false;
    }

    // Check for extremely short titles (likely malformed)
    if (title.length < 10) {
      return false;
    }

    // Check for invalid year
    const year = result.year;
    if (year && (year < 1900 || year > new Date().getFullYear() + 5)) {
      return false;
    }

    return true;
  }

  private convertGradeQualityFromString(quality?: string): string {
    if (!quality) return '';

    // Convert readable format back to snake_case for database
    const normalized = quality.toLowerCase().trim();

    switch (normalized) {
      case 'very low':
      case 'very_low':
      case 'molto bassa':
      case 'molto basso':
        return 'very_low';
      case 'low':
      case 'bassa':
      case 'basso':
        return 'low';
      case 'moderate':
      case 'medium':
      case 'moderata':
      case 'moderato':
        return 'moderate';
      case 'high':
      case 'alta':
      case 'alto':
        return 'high';
      default:
        // Handle complex Italian descriptions with context
        if (normalized.includes('molto bassa') || normalized.includes('very low')) return 'very_low';
        if (normalized.includes('bassa') || normalized.includes('low')) return 'low';
        if (normalized.includes('alta') || normalized.includes('high') || normalized.includes('ampio')) return 'high';
        if (normalized.includes('moderata') || normalized.includes('moderate')) return 'moderate';
        return normalized.replace(/\s+/g, '_');
    }
  }

  private convertRiskOfBias(
    riskOfBias?: string
  ): 'very_high' | 'high' | 'moderate' | 'low' {
    if (!riskOfBias) return 'moderate';

    const normalized = riskOfBias.toLowerCase().trim();

    switch (normalized) {
      case 'very high':
      case 'very_high':
      case 'molto alto':
        return 'very_high';
      case 'high':
      case 'alto':
        return 'high';
      case 'moderate':
      case 'medium':
      case 'moderato':
        return 'moderate';
      case 'low':
      case 'basso':
        return 'low';
      default:
        // Handle complex Italian descriptions
        if (normalized.includes('molto alto') || normalized.includes('very high')) return 'very_high';
        if (normalized.includes('alto') || normalized.includes('high')) return 'high';
        if (normalized.includes('basso') || normalized.includes('low')) return 'low';
        if (normalized.includes('moderato') || normalized.includes('moderate')) return 'moderate';
        return 'moderate';
    }
  }

  /**
   * Convert grade quality from Italian/database format to readable English format for display
   */
  private convertGradeQualityToReadable(quality?: string): string {
    if (!quality) return '';

    const normalized = quality.toLowerCase().trim();

    switch (normalized) {
      case 'very_low':
      case 'molto bassa':
      case 'molto basso':
        return 'Very Low';
      case 'low':
      case 'bassa':
      case 'basso':
        return 'Low';
      case 'moderate':
      case 'medium':
      case 'moderata':
      case 'moderato':
        return 'Moderate';
      case 'high':
      case 'alta':
      case 'alto':
        return 'High';
      default:
        // Handle complex Italian descriptions with context
        if (normalized.includes('molto bassa') || normalized.includes('very low')) return 'Very Low';
        if (normalized.includes('bassa') || normalized.includes('low')) return 'Low';
        if (normalized.includes('alta') || normalized.includes('high') || normalized.includes('ampio')) return 'High';
        if (normalized.includes('moderata') || normalized.includes('moderate')) return 'Moderate';
        // Capitalize first letter for display
        return quality.charAt(0).toUpperCase() + quality.slice(1);
    }
  }

  /**
   * Convert risk of bias from Italian/database format to readable English format for display
   */
  private convertRiskOfBiasToReadable(riskOfBias?: string): string {
    if (!riskOfBias) return 'Moderate';

    const normalized = riskOfBias.toLowerCase().trim();

    switch (normalized) {
      case 'very_high':
      case 'molto alto':
      case 'molto alta':
        return 'Very High';
      case 'high':
      case 'alto':
      case 'alta':
        return 'High';
      case 'moderate':
      case 'moderato':
      case 'moderata':
        return 'Moderate';
      case 'low':
      case 'basso':
      case 'bassa':
        return 'Low';
      default:
        // Handle complex Italian descriptions
        if (normalized.includes('molto alto') || normalized.includes('very high')) return 'Very High';
        if (normalized.includes('alto') || normalized.includes('high')) return 'High';
        if (normalized.includes('basso') || normalized.includes('low')) return 'Low';
        if (normalized.includes('moderato') || normalized.includes('moderate')) return 'Moderate';
        // Capitalize first letter for display
        return riskOfBias.charAt(0).toUpperCase() + riskOfBias.slice(1);
    }
  }

  private loadProjectGradeRevisions(): void {
    if (this.project_id) {
      // First try project-specific endpoint
      const subscription = this.gradeService
        .getRevisionsByProjectId(this.project_id)
        .subscribe({
          next: (revisions) => {

            // Ensure revisions is an array
            const allRevisions = Array.isArray(revisions) ? revisions : [];

            // Filter to show only "Grade Analysis" revisions and rename them with PICO question
            this.gradeRevisions = this.filterAndRenameGradeAnalysis(allRevisions);

            // Sort revisions from oldest to newest (by created_at)
            this.gradeRevisions.sort((a, b) => {
              const dateA = new Date(a.created_at).getTime();
              const dateB = new Date(b.created_at).getTime();
              return dateA - dateB;
            });

            setTimeout(() => {
              // console.log(' Delayed check - gradeRevisions length:', this.gradeRevisions.length);
            }, 100);

          },
          error: (error) => {
            console.error(
              'Error loading project-specific grade revisions:',
              error
            );
            console.error(
              'Error details:',
              error.message,
              error.status,
              error.error
            );
            console.error('Full error object:', error);
            this.gradeRevisions = [];

            // Try fallback endpoint to test connectivity
            // console.log(
            //   'Fallback: Testing general grade revisions endpoint due to error...'
            // );
            this.testGeneralGradeRevisionsEndpoint();
          },
        });
      this.subscriptions.push(subscription);
    } else {
      console.log('Current project_id value:', this.project_id);
    }
  }

  private testGeneralGradeRevisionsEndpoint(): void {
    const fallbackSubscription = this.gradeService.getRevisions().subscribe({
      next: (allRevisions) => {
        console.log(
          ' Total revisions in system:',
          Array.isArray(allRevisions) ? allRevisions.length : 0
        );

        if (Array.isArray(allRevisions) && allRevisions.length > 0) {

          // Filter manually to see if there are matching revisions
          const matchingRevisions = allRevisions.filter(
            (rev) => rev.organization_project_id === Number(this.project_id)
          );

        } else {
          console.log(' No revisions found in general endpoint either');
        }
      },
      error: (error) => {
        console.error(' General revisions endpoint also failed:', error);
      },
    });
    this.subscriptions.push(fallbackSubscription);
  }

  private hasPicoChanged(): boolean {
    // Simple check - in a real implementation, you'd compare with previous values
    return !!(
      this.patients &&
      this.intervention &&
      this.comparison &&
      this.outcomes
    );
  }

  private handlePicoQuestionChange(): void {
    if (!this.project_id || !this.question) return;

    const searchParams = {
      patients: this.patients,
      intervention: this.intervention,
      comparison: this.comparison,
      outcomes: this.outcomes,
      keywords: this.keywords,
    };

    const subscription = this.gradeService
      .handlePicoQuestionChange(
        this.project_id,
        this.question,
        this.keywords?.toString() || '',
        searchParams
      )
      .subscribe({
        next: (revision) => {
          this.currentGradeRevision = revision;
        },
        error: (error) => {
          console.error(
            'Error creating grade revision for PICO change:',
            error
          );
        },
      });

    this.subscriptions.push(subscription);
  }

  public onGradeRevisionSelected(revision: GradeRevision): void {
    this.currentGradeRevision = revision;
  }

  public onGradeDocumentSelected(document: GradeDocument): void {
    // console.log('Document selected:', document);
  }

  public onGradeRevisionDeleted(revisionId: number): void {
    if (this.currentGradeRevision?.id === revisionId) {
      this.currentGradeRevision = null;
    }
    this.loadProjectGradeRevisions();
  }

  // Enhanced search method with grade revision support
  public searchTermInPublmedEnhanced(saveToProject: boolean = true): void {
    let results = [];

    this.loading = true;
    this.biblioSearchStatus = 'pending';

    const query = this.keywordsForChipList.toString();
    // const query = this.keywords.toString();
    const maxResultsPerPage = 50;

    // Create PICO question string for revision title
    const picoQuestion =
      this.question ||
      `P: ${this.patients} I: ${this.intervention} C: ${this.comparison} O: ${this.outcomes}`;


    this.backend
      .post(`tools/pubmed/search`, {
        term: query,
        page: 1,
        maxResultsPerPage: maxResultsPerPage,
      })
      .subscribe(
        (result) => {
          this.pubmedResultsCached[1] = result;
          this.searchNumItems = parseInt(
            this.pubmedResultsCached[1]?.total_items
          );

          if (!this.searchNumItems) {
            this.biblioSearchStatus = null;
            return;
          }

          this.pubmedResults = this.pubmedResultsCached[1];

          this.pubmedResults.articles.map((a) => {
            let article = {
              title: a.ArticleTitle,
              authors: a.Authors,
              PMID: a.PMID,
              Doid: a.Doid,
              pubyear: a.PubYear,
              pubmonth: a.PubMonth,
              pubday: a.PubDay,
              pii: a.Pii,
              ISSN: a.ISSN,
              volume: a.Volume,
              link: a.link,
            };
            results.push(article);
          });

          // Include individual PICO components in the request for database storage
          const searchParams = {
            patients: this.patients,
            intervention: this.intervention,
            comparison: this.comparison,
            outcomes: this.outcomes,
            keywords: this.keywords,
          };

          const data = {
            organization_id: this.project.organization_id,
            organization_project_id: this.project_id, // Link revision to this project
            statement: results,
            question: this.question,
            keywords: this.keywords.toString(), // Clean keywords only
            pico_question: picoQuestion, // Include PICO question for grade revision storage
            search_query: picoQuestion, // Also store in search_query for compatibility
            search_parameters: searchParams, // Backend will overwrite this with metadata
          };

          // Store PICO components to update the revision after AI completion
          this.pendingPicoComponents = searchParams;

          // Set flag to indicate backend is handling grade revision creation
          this.backendHandlingGradeRevision = true;

          // Use enhanced method that properly saves grade revisions with all fields
          this.aiService.generateLiteratireReviewTableWithPubmedArticlesEnhanced(
            data,
            true, // saveToProject = true to ensure grade revision is saved
            (result) => {
              this.currentProcessId = result.process_id;
              // Don't set loading = false here! Keep spinner until completion
              this.aiService.startPolling(result.process_id);
            },
            (error) => {
              this.biblioSearchStatus = null;
            }
          );
        },
        (error) => {
          console.log(error);
          this.backend.showErrors(error);
          this.loading = false;
          this.biblioSearchStatus = null;
        }
      );
  }

  /**
   * Opens a document link (DOI, PubMed, PDF, etc.) in a new tab
   */
  openDocumentLink(article: GradeTable): void {
    // Priority order: PDF file, DOI, PubMed link, external link
    let url: string | undefined;

    if (article.pdf_file_path) {
      // Handle PDF file download/view
      url = `/api/documents/pdf/${article.pdf_file_path}`; // Adjust path as needed
    } else if (article.doi) {
      url = this.generateDoiLink(article.doi);
    } else if (article.pmid) {
      url = this.generatePubMedLink(article.pmid);
    } else if (article.link) {
      url = article.link;
    }

    if (url) {
      window.open(url, '_blank');
    }
  }

  /**
   * Checks if an article has any available link
   */
  hasDocumentLink(article: GradeTable): boolean {
    const hasLink = !!(article.pdf_file_path || article.doi || article.pmid || article.link);

    return hasLink;
  }

  /**
   * Gets the link type description for tooltip
   */
  getLinkTypeDescription(article: GradeTable): string {
    if (article.pdf_file_path) {
      return 'Click to view PDF document';
    } else if (article.doi) {
      return `Click to view on DOI: ${article.doi}`;
    } else if (article.pmid) {
      return `Click to view on PubMed: ${article.pmid}`;
    } else if (article.link) {
      return 'Click to view external document';
    }
    return 'Click to view document';
  }

  /**
   * Removes a document from the table and database
   */
  removeDocument(article: GradeTable): void {
    if (!article.id) {
      // For documents that don't have an ID (new search results not yet saved)
      this.removeFromTableOnly(article);
      return;
    }

    // Confirm deletion
    if (confirm(`Are you sure you want to remove "${article.articleTitle}"? This action cannot be undone.`)) {
      const deleteSubscription = this.gradeService
        .deleteDocument(article.id)
        .subscribe({
          next: () => {
            // Remove from table
            this.removeFromTableOnly(article);
          },
          error: (error) => {
            console.error('Error deleting document:', error);
            this.showErrorToast('Failed to delete document. Please try again.');
          }
        });

      this.subscriptions.push(deleteSubscription);
    }
  }

  /**
   * Removes a document from the table only (for UI updates)
   */
  private removeFromTableOnly(article: GradeTable): void {
    const currentData = this.biblioSearchDataSource.data;
    const filteredData = currentData.filter(item => {
      // Compare by ID if available, otherwise by title and authors
      if (article.id && item.id) {
        return item.id !== article.id;
      }
      return !(item.articleTitle === article.articleTitle &&
               item.authors === article.authors &&
               item.year === article.year);
    });

    this.biblioSearchDataSource.data = filteredData;
  }

  /**
   * Gets the active grade revision ID (only if explicitly selected)
   */
  private getActiveGradeRevisionId(): number | null {
    return this.currentGradeRevision?.id || null;
  }

  /**
   * Handles adding new evidence/document
   */
  onRevisionSelectForAddDocument(revision: GradeRevision, event: Event): void {
    event.stopPropagation();
    // Always ensure the revision is set as current before adding a document
    if (this.currentGradeRevision?.id !== revision.id) {
      this.currentGradeRevision = revision;
      this.loadRevisionDocuments(revision);
    }
  }

  onClickAddNewDocument(type: 'PDF' | 'PUBMED'): void {
    if (type === 'PDF') {
      this.onClickAddPDFDocument();
    } else if (type === 'PUBMED') {
      this.onClickAddPubMedDocument();
    }
  }

  /**
   * Handles adding new PDF document using modal
   */
  private onClickAddPDFDocument(): void {
    const dialogRef = this.dialog.open(ModalAddAttachmentComponent, {
      panelClass: 'large-dialog',
      data: {
        title: 'modals.modal-add-attachment.add-evidences',
        attachmentType: 'FILE',
        uploadUrl: 'upload/grade-document',
        maxUploadsFile: 1
      }
    });

    dialogRef.afterClosed().subscribe((attachmentData) => {
      if (attachmentData && attachmentData.attachmentObject) {
        this.handleAttachmentResult(attachmentData.attachmentObject, 'PDF');
      }
    });
  }

  /**
   * Handles adding new PubMed document using modal
   */
  private onClickAddPubMedDocument(): void {
    const dialogRef = this.dialog.open(ModalAddAttachmentComponent, {
      panelClass: 'large-dialog',
      data: {
        title: 'modals.modal-add-attachment.add-evidences',
        attachmentType: 'PUBMED'
      }
    });

    dialogRef.afterClosed().subscribe((attachmentData) => {
      if (attachmentData && attachmentData.attachmentObject) {
        const articles = Array.isArray(attachmentData.attachmentObject)
          ? attachmentData.attachmentObject
          : [attachmentData.attachmentObject];

        articles.forEach((art) => {
          this.handleAttachmentResult(art, 'PUBMED');
        });
      }
    });
  }

  /**
   * Handles the result from the attachment modal
   */
  private handleAttachmentResult(attachmentObject: any, type: 'PDF' | 'PUBMED'): void {
    const gradeRevisionId = this.getActiveGradeRevisionId();
    if (!gradeRevisionId) {
      this.showErrorToast('Please select a grade revision first by clicking on an existing revision.');
      return;
    }

    // Handle array structure - extract the first element if it's an array
    let fileData = attachmentObject;
    if (Array.isArray(attachmentObject) && attachmentObject.length > 0) {
      fileData = attachmentObject[0];
    }


    if (type === 'PDF') {
      // For PDF: Check if upload provided path/documentId

      // Check for direct document ID first using the extracted fileData
      const hasDocumentId = !!(fileData.documentId || fileData.id);
      const hasDirectPath = !!(fileData.path);
      const hasNestedPath = !!(fileData.file?.path);
      const hasPath = hasDirectPath || hasNestedPath;

      if (hasDocumentId) {
        // Upload completed and returned a document ID - now process it
        const documentId = fileData.documentId || fileData.id;
        this.processSingleDocument(documentId, gradeRevisionId, type, attachmentObject);
      } else if (hasPath) {
        // Upload returned a file path - extract identifier and process

        // Get path from either direct property or nested file object using fileData
        const filePath = fileData.path || fileData.file?.path;

        const documentId = this.extractDocumentIdFromPath(filePath);
        if (documentId) {
          this.processSingleDocument(documentId, gradeRevisionId, type, attachmentObject);
        } else {
          const documentUrl = this.extractDocumentUrl(attachmentObject, type);
          if (!documentUrl) {
            this.showErrorToast(`Failed to extract URL for ${type} document. Please try again.`);
            return;
          }
          this.processAndSaveDocument(gradeRevisionId, documentUrl, type, attachmentObject);
        }
      } else {
        const documentUrl = this.extractDocumentUrl(attachmentObject, type);
        if (!documentUrl) {
          this.showErrorToast(`Failed to extract URL for ${type} document. Please try again.`);
          return;
        }
        this.processAndSaveDocument(gradeRevisionId, documentUrl, type, attachmentObject);
      }
    } else {
      // For PubMed: Continue with existing approach
      const documentUrl = this.extractDocumentUrl(attachmentObject, type);
      if (!documentUrl) {
        this.showErrorToast(`Failed to extract URL for ${type} document. Please try again.`);
        return;
      }
      this.processAndSaveDocument(gradeRevisionId, documentUrl, type, attachmentObject);
    }
  }

  /**
   * Processes a single document by calling the new documents/{documentId}/process-single-document endpoint
   * @param documentId The ID of the uploaded document
   * @param gradeRevisionId The ID of the grade revision to attach the document to
   * @param type The type of document (PDF or PUBMED)
   * @param attachmentObject Original attachment object for additional metadata
   */
  private processSingleDocument(documentId: string | number, gradeRevisionId: number, type: 'PDF' | 'PUBMED', attachmentObject: any): void {

    // Set processing state to show spinner
    this.isProcessingSingleDocument = true;

    // Get the current PICO search question for the selected revision
    const picoSearchQuestion =
      this.currentGradeRevision?.pico_question ||
      this.currentGradeRevision?.search_query ||
      this.question ||
      'Document analysis for grade revision';


    // Create the request payload for the new endpoint
    const requestPayload: any = {
      gradeRevisionId: gradeRevisionId,
      picoSearchQuestion: picoSearchQuestion,
      attachmentObject: attachmentObject[0].file, // Pass original attachment for metadata
      pdf_url: attachmentObject[0].file.link,
    };


    // Call the new documents/{documentId}/process-single-document endpoint
    const processSubscription = this.backend
      .post(
        `grade/documents/${documentId}/process-single-document`,
        requestPayload
      )
      .subscribe({
        next: (response: any) => {

          // Check if response has a 'document' property, otherwise use the response directly
          let processedDocument = response.document || response;

          // Check if the backend returned a valid document object
          if (!processedDocument) {
            console.error(
              ' Backend returned null - document processing may have failed'
            );
            this.showErrorToast(
              `Failed to process ${type} document. The backend returned an empty response. Please check the backend logs and try again.`
            );
            return;
          }

          // Check if backend saved the document (has ID) or just processed it (no ID)
          if (processedDocument.id) {

            // Backend saved it, just add to frontend table
            const tableEntry: GradeTable = this.convertGradeDocumentToLegacyTable(processedDocument);
            const currentData = this.biblioSearchDataSource.data;
            this.biblioSearchDataSource.data = [...currentData, tableEntry];
            this.biblioSearchDataSource._updateChangeSubscription();

          } else {
            console.log(' Backend processed but did not save document - frontend will save it');

            // Backend only processed, frontend needs to save to database
            this.saveProcessedDocumentToDatabase(
              processedDocument,
              gradeRevisionId,
              type,
              attachmentObject
            );
          }

          // Refresh grade revisions to show updated document count
          setTimeout(() => {
            this.loadProjectGradeRevisions();
          }, 500);

          // Reset processing state
          this.isProcessingSingleDocument = false;

          // this.showSuccessToast(
          //   `${type} document processed and saved successfully!`
          // );
        },
        error: (error) => {
          console.error(`Error processing ${type} document:`, error);
          this.showErrorToast(
            `Failed to process ${type} document: ${
              error.message || 'Unknown error'
            }`
          );

          // Reset processing state
          this.isProcessingSingleDocument = false;
        },
      });

    // Store subscription for cleanup
    this.subscriptions.push(processSubscription);
  }

  /**
   * Processes and saves a document by calling the backend processing endpoint (legacy method)
   * This will save the document to the database and return processed data
   * @param gradeRevisionId The ID of the grade revision to attach the document to
   * @param documentUrl The URL of the document
   * @param type The type of document (PDF or PUBMED)
   * @param attachmentObject Original attachment object for additional metadata
   */
  private processAndSaveDocument(gradeRevisionId: number, documentUrl: string, type: 'PDF' | 'PUBMED', attachmentObject: any): void {

    // Set processing state to show spinner
    this.isProcessingSingleDocument = true;

    // Get the current PICO search question for the selected revision
    const picoSearchQuestion = this.currentGradeRevision?.pico_question ||
                               this.currentGradeRevision?.search_query ||
                               this.question ||
                               'Document analysis for grade revision';

    // Create the request payload matching backend parameter names
    const requestPayload: any = {
      gradeRevisionId: gradeRevisionId,
      picoSearchQuestion: picoSearchQuestion
    };

    // Add the appropriate URL parameter based on document type
    if (type === 'PDF') {
      requestPayload.pdf_url = documentUrl;
      requestPayload.pubmed_url = null;
    } else {
      // For PubMed, send formatted metadata object instead of just URL
      requestPayload.pdf_url = null;
      requestPayload.pubmed_url = this.formatPubMedData(attachmentObject);
    }

    const processSubscription = this.backend.post('grade/documents/process-single-document', requestPayload)
      .subscribe({
        next: (response: any) => {
          // Check if response has a 'document' property, otherwise use the response directly
          let processedDocument = response.document || response;

          // Check if the backend returned a valid document object
          if (!processedDocument) {
            console.error(' Backend returned null - document processing may have failed');
            this.showErrorToast(`Failed to process ${type} document. The backend returned an empty response. Please check the backend logs and try again.`);
            return;
          }

          // More flexible validation - the document should have an ID (meaning it was saved)
          // but the processing might be incomplete
          if (!processedDocument.id && processedDocument.id !== 0) {
            console.error(' This means the document was not saved to database');
            this.showErrorToast(`Failed to process ${type} document. The document was not saved. Please try again.`);
            return;
          }

          // Check if the document has meaningful processed data or if it's mostly empty
          const hasProcessedData = processedDocument.authors ||
                                 processedDocument.year ||
                                 processedDocument.study_type ||
                                 processedDocument.main_outcome ||
                                 processedDocument.precision ||
                                 processedDocument.consistency ||
                                 processedDocument.grade_quality ||
                                 processedDocument.abstract;


          if (!hasProcessedData) {
            console.warn('Backend saved document but didn\'t populate GRADE analysis fields properly');

            // Try to extract data from additional_data.document_info if available
            let enhancedDocument = { ...processedDocument };
            if (processedDocument.additional_data?.document_info) {
              const docInfo = processedDocument.additional_data.document_info;
              enhancedDocument.title = enhancedDocument.title || docInfo.title;
            }

            processedDocument = enhancedDocument;

          }


          // Check if this is already a saved document (has an ID) or just processed data
          if (processedDocument.id) {
            // Refresh revisions and table to show updated document count
            this.refreshAfterDocumentProcessing();

            // Show appropriate success message based on data completeness
            if (hasProcessedData) {
              // this.showSuccessToast(`${type} document has been processed and added successfully!`);
            } else {
              this.showToast(`${type} document has been added successfully but AI analysis is incomplete. You may need to manually review and update the GRADE assessment fields.`);
            }

            // Make sure loading is turned off
            this.loading = false;

            // Reset processing state
            this.isProcessingSingleDocument = false;
          } else {
            // Backend returned processed data but didn't save it - we need to save it manually
            console.log(' Backend processed but did not save document - frontend will save it');
            this.saveProcessedDocumentToDatabase(processedDocument, gradeRevisionId, type, attachmentObject);

            // Refresh grade revisions to show updated document count
            setTimeout(() => {
              this.loadProjectGradeRevisions();
            }, 500);

            // Reset processing state
            this.isProcessingSingleDocument = false;
          }
        },
        error: (error) => {
          console.error(` Error processing ${type} document:`, error);
          console.error(' Error status:', error.status);
          console.error(' Error message:', error.message);
          console.error(' Error body:', error.error);
          console.error(' Full error object:', error);

          // Show more detailed error information to user
          let errorMessage = `Failed to process ${type} document.`;
          if (error.status) {
            errorMessage += ` (HTTP ${error.status})`;
          }
          if (error.error && typeof error.error === 'string') {
            errorMessage += `\nDetails: ${error.error}`;
          } else if (error.error && error.error.message) {
            errorMessage += `\nDetails: ${error.error.message}`;
          }

          this.showErrorToast(errorMessage);
          this.backend.showErrors(error);

          // Make sure loading is turned off
          this.loading = false;

          // Reset processing state
          this.isProcessingSingleDocument = false;
        }
      });

    this.subscriptions.push(processSubscription);
  }

  /**
   * Formats PubMed data into the required structure for backend processing
   * @param pubmedElement The PubMed element from the attachment modal
   * @returns Formatted PubMed data object with metadata
   */
  private formatPubMedData(pubmedElement: any): any {

    const formattedData = {
      url: pubmedElement.link || `https://pubmed.ncbi.nlm.nih.gov/${pubmedElement.PMID}/`,
      metadata: {
        authors: `[authors]: ${pubmedElement.Authors || ''}`,
        pmid: `[PMID]: ${pubmedElement.PMID || ''}`,
        pubyear: `[pubyear]: ${pubmedElement.PubYear || ''}`,
        pii: `[pii]: ${pubmedElement.Pii || ''}`,
        issn: `[ISSN]: ${pubmedElement.ISSN || ''}`,
        volume: `[v]: ${pubmedElement.Volume || ''}`,
        doi: `[DOI]: ${pubmedElement.Doid || pubmedElement.DOI || ''}`
      },
      // Also include raw data for backend processing
      raw_data: {
        ArticleTitle: pubmedElement.ArticleTitle,
        Authors: pubmedElement.Authors,
        PMID: pubmedElement.PMID,
        Doid: pubmedElement.Doid,
        PubYear: pubmedElement.PubYear,
        PubMonth: pubmedElement.PubMonth,
        PubDay: pubmedElement.PubDay,
        Pii: pubmedElement.Pii,
        ISSN: pubmedElement.ISSN,
        Volume: pubmedElement.Volume,
        link: pubmedElement.link
      }
    };


    return formattedData;
  }

  /**
   * Refreshes the project revisions and current table after document processing
   */
  private refreshAfterDocumentProcessing(): void {

    // Refresh project revisions to show updated document count
    this.loadProjectGradeRevisions();

    // Immediate simple refresh - call the API right away without delay
    this.simpleTableRefresh();
  }

  /**
   * Simple immediate table refresh from database
   */
  private simpleTableRefresh(): void {
    if (!this.currentGradeRevision) {
      console.log('No current revision selected, cannot refresh table');
      return;
    }


    this.loading = true;

    // Direct API call to get fresh documents
    const refreshSubscription = this.gradeService
      .getDocuments({
        grade_revision_id: this.currentGradeRevision.id,
      })
      .subscribe({
        next: (documents) => {

          // Update the revision's cached documents
          this.currentGradeRevision!.documents = documents;

          // Populate table with fresh documents
          this.populateTableWithDocuments(documents);
          this.loading = false;

        },
        error: (error) => {
          console.error(' Error in simple table refresh:', error);
          this.loading = false;
        }
      });

    this.subscriptions.push(refreshSubscription);
  }

  /**
   * Refreshes table specifically from database for a given grade revision ID
   */
  private refreshTableFromDatabase(gradeRevisionId: number): void {

    this.loading = true;

    // Direct API call to get fresh documents from database
    const refreshSubscription = this.gradeService
      .getDocuments({
        grade_revision_id: gradeRevisionId,
      })
      .subscribe({
        next: (documents) => {

          // Update the table with fresh database data
          this.populateTableWithDocuments(documents);

          // Update the cached documents in the revision if it's currently selected
          if (this.currentGradeRevision && this.currentGradeRevision.id === gradeRevisionId) {
            this.currentGradeRevision.documents = documents;
          }

          this.loading = false;
        },
        error: (error) => {
          this.loading = false;

          // Fallback to existing table data if available
          console.log(' Database refresh failed - keeping existing table data');
        }
      });

    this.subscriptions.push(refreshSubscription);
  }

  /**
   * Forces a complete table refresh from database
   */
  private forceTableRefresh(): void {
    if (!this.currentGradeRevision) {
      return;
    }

    // Use the new refresh method
    this.refreshTableFromDatabase(this.currentGradeRevision.id);

    // Also clear cached documents to force fresh API call
    if (this.currentGradeRevision.documents) {
      this.currentGradeRevision.documents = [];
    }

    // Additional delayed refresh to ensure database consistency
    setTimeout(() => {
      this.refreshTableFromDatabase(this.currentGradeRevision!.id);
    }, 2000);

    // Final refresh with longer delay
    setTimeout(() => {
      this.forceLoadRevisionDocuments(this.currentGradeRevision!);
    }, 4000);
  }

  /**
   * Forces loading revision documents from API, bypassing cache
   */
  private forceLoadRevisionDocuments(revision: GradeRevision): void {

    this.loading = true;

    // Always load from API, ignore cached documents
    const documentsSubscription = this.gradeService
      .getDocuments({
        grade_revision_id: revision.id,
      })
      .subscribe({
        next: (documents) => {

          // Update the revision's cached documents
          revision.documents = documents;

          // Populate table with fresh documents
          this.populateTableWithDocuments(documents);
          this.loading = false;
        },
        error: (error) => {
          console.error(' Error loading documents:', error);
          this.loading = false;
        }
      });

    this.subscriptions.push(documentsSubscription);
  }

  /**
   * Saves processed document data to the database using GradeService
   * @param processedData The processed document data from backend
   * @param gradeRevisionId The grade revision ID
   * @param type The document type (PDF or PUBMED)
   * @param attachmentObject Original attachment object for additional metadata
   */
  private saveProcessedDocumentToDatabase(processedData: any, gradeRevisionId: number, type: 'PDF' | 'PUBMED', attachmentObject: any): void {

    // Create a GradeDocument request from the processed data
    const documentRequest: CreateGradeDocumentRequest = {
      grade_revision_id: gradeRevisionId,
      title: processedData.title || processedData.articleTitle || attachmentObject.ArticleTitle || 'Untitled Document',
      authors: processedData.authors || attachmentObject.Authors || '',
      year: processedData.year || processedData.pubyear || attachmentObject.PubYear || new Date().getFullYear(),
      journal: processedData.journal || '',
      doi: processedData.doi || attachmentObject.Doid || attachmentObject.DOI || '',
      pmid: processedData.pmid || attachmentObject.PMID || '',
      abstract: processedData.abstract || '',
      study_type: processedData.study_type || processedData.studyType || '',
      main_outcome: processedData.main_outcome || processedData.mainOutcome || '',
      precision: this.convertGradeQualityFromString(processedData.precision) as GradeQuality,
      consistency: this.convertGradeQualityFromString(processedData.consistency) as GradeQuality,
      risk_of_bias: this.convertRiskOfBias(processedData.risk_of_bias || processedData.riskOfBias),
      grade_quality: this.convertGradeQualityFromString(processedData.grade_quality || processedData.gradeQuality) as GradeQuality,
      source_type: type === 'PDF' ? 'manual_upload' : 'manual_entry',
      additional_data: {
        processed_by_ai: true,
        processing_timestamp: new Date().toISOString(),
        original_attachment_data: attachmentObject,
        ai_processing_result: processedData,
        document_type: type,
        // Preserve identifiers for link generation
        doi: processedData.doi || attachmentObject.Doid || attachmentObject.DOI,
        pmid: processedData.pmid || attachmentObject.PMID,
        pdf_file_path: type === 'PDF' ? this.extractDocumentUrl(attachmentObject, 'PDF') : undefined
      }
    };


    // Save the document using GradeService
    const saveSubscription = this.gradeService.createDocument(documentRequest).subscribe({
      next: (savedDocument) => {

        // Refresh revisions and table to show updated document count
        this.refreshAfterDocumentProcessing();

        // Show success message
        // this.showSuccessToast(`${type} document has been processed and saved successfully!`);
      },
      error: (error) => {
        console.error(' Error saving processed document to database:', error);
        console.error(' Document request that failed:', documentRequest);

        // Show error but still try to add to table for user visibility
        this.showErrorToast(`${type} document was processed but failed to save to database. You may need to try again.`);

        // Optionally still try to show in table (without database persistence)
        try {
          const tableEntry: GradeTable = {
            id: undefined, // No ID since it wasn't saved
            authors: documentRequest.authors,
            year: documentRequest.year,
            articleTitle: documentRequest.title,
            studyType: documentRequest.study_type,
            mainOutcome: documentRequest.main_outcome,
            precision: this.convertGradeQualityToString(documentRequest.precision),
            consistency: this.convertGradeQualityToString(documentRequest.consistency),
            riskOfBias: documentRequest.risk_of_bias,
            gradeQuality: this.convertGradeQualityToString(documentRequest.grade_quality),
            doi: documentRequest.doi,
            pmid: documentRequest.pmid,
            pdf_file_path: documentRequest.additional_data?.pdf_file_path,
            link: type === 'PUBMED' ? this.generatePubMedLink(documentRequest.pmid) : undefined
          };

          const currentData = this.biblioSearchDataSource.data;
          this.biblioSearchDataSource.data = [...currentData, tableEntry];
        } catch (tableError) {
          console.error(' Failed to add document to table:', tableError);
        }
      }
    });

    this.subscriptions.push(saveSubscription);
  }

  /**
   * Extracts document ID from file path
   * @param filePath The file path from upload response (e.g., "attachments/grade-document/68c13fc830031.pdf")
   * @returns The document identifier or null if not found
   */
  private extractDocumentIdFromPath(filePath: string): string | null {
    if (!filePath) return null;

    try {
      // Extract filename from path and remove extension
      // e.g., "attachments/grade-document/68c13fc830031.pdf" -> "68c13fc830031"
      const filename = filePath.split('/').pop(); // Get last part of path
      if (!filename) return null;

      const documentId = filename.replace(/\.[^/.]+$/, ''); // Remove extension
      // console.log('Extracted document ID from path:', {
      //   originalPath: filePath,
      //   filename: filename,
      //   documentId: documentId
      // });

      return documentId || null;
    } catch (error) {
      console.error('Error extracting document ID from path:', error);
      return null;
    }
  }

  /**
   * Extracts the document URL from attachment object based on type
   * @param attachmentObject The attachment object from the modal
   * @param type The type of document (PDF or PUBMED)
   * @returns The URL of the document or null if not found
   */
  private extractDocumentUrl(attachmentObject: any, type: 'PDF' | 'PUBMED'): string | null {
    // Handle array structure - extract the first element if it's an array
    let fileData = attachmentObject;
    if (Array.isArray(attachmentObject) && attachmentObject.length > 0) {
      fileData = attachmentObject[0];
    }

    if (type === 'PDF') {
      // For PDF files, check both direct properties and nested file object
      return fileData.url ||
             fileData.file_url ||
             fileData.path ||
             fileData.link ||
             fileData.file?.path ||
             fileData.file?.link ||
             fileData.file?.url ||
             null;
    } else if (type === 'PUBMED') {
      // For PubMed, construct the URL from PMID or use provided link
      const pmid = fileData.PMID || fileData.pmid;
      if (pmid) {
        return `https://pubmed.ncbi.nlm.nih.gov/${pmid}/`;
      }
      return fileData.link ||
             fileData.url ||
             null;
    }

    return null;
  }


  /**
   * Updates a grade revision with PICO components after AI processing completes
   * This ensures PICO data is stored without polluting the keywords field
   */
  private updateGradeRevisionWithPicoComponents(gradeRevisionId: number): void {
    if (!this.pendingPicoComponents || !gradeRevisionId) {
      return;
    }


    // Store PICO components in the description field in JSON format for retrieval
    const picoDescription = JSON.stringify({
      type: 'PICO_COMPONENTS',
      data: this.pendingPicoComponents,
      timestamp: new Date().toISOString()
    });

    const updateData = {
      description: picoDescription
    };

    const updateSubscription = this.gradeService
      .updateRevision(gradeRevisionId, updateData)
      .subscribe({
        next: (updatedRevision) => {
          // Clear pending components
          this.pendingPicoComponents = null;

          // Refresh revisions to show updated data
          setTimeout(() => {
            this.loadProjectGradeRevisions();
          }, 1000);
        },
        error: (error) => {
          // Don't clear pendingPicoComponents on error - might retry
        }
      });

    this.subscriptions.push(updateSubscription);
  }

  /**
   * Populates the keywords and PICO question textboxes with data from the selected revision
   * @param revision The selected grade revision
   */
  private populateTextboxesFromRevision(revision: GradeRevision): void {


    // Based on the actual data structure, search_query contains the PICO question
    // and we need to determine what should go in keywords vs PICO question

    // Populate PICO question textbox first (this gets the search_query which is the PICO question)
    if (revision.search_query) {
      this.question = revision.search_query;
    } else if (revision.pico_question) {
      this.question = revision.pico_question;
    }

    // Handle keywords population (clean approach - no PICO data mixing)

    if (
      revision.keywords &&
      revision.keywords !== null &&
      revision.keywords.trim() !== ''
    ) {
      // Use keywords as-is (should be clean now)
      this.keywords = revision.keywords;
    } else {
      // If revision doesn't have keywords stored, clear the field
      this.keywords = '';
    }

    // Get PICO components from dedicated fields or search_parameters
    let picoParams = null;

    // Primary: check description field for PICO components (new clean approach)
    if (revision.description) {
      try {
        const descriptionData = JSON.parse(revision.description);
        if (descriptionData.type === 'PICO_COMPONENTS' && descriptionData.data) {
          picoParams = descriptionData.data;
        }
      } catch (e) {
        // Description field is not JSON or not PICO components format
      }
    }

    // Fallback: check search_parameters (might have PICO components for older revisions)
    if (!picoParams && revision.search_parameters && typeof revision.search_parameters === 'object') {
      const params = revision.search_parameters;

      if (params.patients || params.intervention || params.comparison || params.outcomes) {
        picoParams = params;
      } else {
        console.log('search_parameters contains metadata, not PICO components');
      }
    }

    // Populate PICO component fields if we found the data
    if (picoParams) {

      if (picoParams.patients) {
        this.patients = picoParams.patients;
      }

      if (picoParams.intervention) {
        this.intervention = picoParams.intervention;
      }

      if (picoParams.comparison) {
        this.comparison = picoParams.comparison;
      }

      if (picoParams.outcomes) {
        this.outcomes = picoParams.outcomes;
      }

      if (picoParams.studies) {
        this.studies = picoParams.studies;
      }

      if (picoParams.timeframe) {
        this.timeframe = picoParams.timeframe;
      }

      // Also populate keywords if available and current keywords are empty
      if (picoParams.keywords && (!this.keywords || this.keywords.trim() === '')) {
        this.keywords = picoParams.keywords;
      }
    }


  }

  /**
   * Deletes a grade revision with confirmation dialog
   * @param revision The revision to delete
   * @param event The click event (to prevent event bubbling)
   */
  deleteRevision(revision: GradeRevision, event: Event): void {
    // Stop event propagation to prevent selecting the revision
    event.stopPropagation();
    event.preventDefault();

    const revisionTitle = revision.pico_question || revision.title || `Grade Revision #${revision.id}`;
    const documentCount = revision.documents?.length || 0;

    // Show confirmation dialog
    const message = documentCount > 0
      ? `Are you sure you want to delete "${revisionTitle}"?\n\nThis will permanently delete the revision and its ${documentCount} associated document${documentCount > 1 ? 's' : ''}.\n\nThis action cannot be undone.`
      : `Are you sure you want to delete "${revisionTitle}"?\n\nThis action cannot be undone.`;

    if (confirm(message)) {

      this.gradeService.deleteRevision(revision.id).subscribe({
        next: () => {

          // Clear current revision if it was the deleted one
          if (this.currentGradeRevision?.id === revision.id) {
            this.currentGradeRevision = null;
            this.biblioSearchDataSource.data = [];
          }

          // Refresh the revisions list
          this.loadProjectGradeRevisions();

          // this.showSuccessToast(`Grade revision "${revisionTitle}" has been deleted successfully.`);
        },
        error: (error) => {
          console.error('Error deleting grade revision:', error);
          this.showErrorToast(`Failed to delete grade revision: ${error.message || 'Unknown error'}`);
        }
      });
    }
  }

  // Export all documents from a specific revision to CSV
  exportRevisionDocuments(revision: GradeRevision): void {
    // If documents are already loaded in the revision, use them
    if (revision.documents && revision.documents.length > 0) {
      const timestamp = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
      const filename = `revision-${revision.id}-documents-export-${timestamp}`;

      this.csvExportService.exportGradeDocumentsToCsv(revision.documents, filename);
      return;
    }

    // If documents are not loaded, fetch them first
    const exportSubscription = this.gradeService.getDocuments({
      grade_revision_id: revision.id
    }).subscribe({
      next: (documents) => {
        if (documents.length === 0) {
          this.showErrorToast(`No documents found for revision: ${revision.title || 'Revision #' + revision.id}`);
          return;
        }

        const timestamp = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
        const filename = `revision-${revision.id}-documents-export-${timestamp}`;

        this.csvExportService.exportGradeDocumentsToCsv(documents, filename);
        this.showSuccessToast(`Exported ${documents.length} documents to CSV successfully.`);
      },
      error: (error) => {
        console.error('Error fetching documents for export:', error);
        this.showErrorToast('Failed to fetch documents for export. Please try again.');
      }
    });

    this.subscriptions.push(exportSubscription);
  }

  // Edit document functionality
  editDocument(document: GradeTable): void {
    const dialogData: EditDocumentDialogData = {
      document: {
        id: document.id || 0,
        grade_revision_id: this.currentGradeRevision?.id || 0,
        title: document.articleTitle,
        authors: document.authors,
        year: document.year,
        study_type: document.studyType,
        main_outcome: document.mainOutcome,
        precision: document.precision as GradeQuality,
        consistency: document.consistency as GradeQuality,
        risk_of_bias: document.riskOfBias as any,
        grade_quality: document.gradeQuality as GradeQuality,
        source_type: 'search',
        is_extracted_from_pdf: false,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      },
      title: 'Edit Document'
    };

    const dialogRef = this.dialog.open(ModalEditDocumentComponent, {
      width: '700px',
      maxWidth: '90vw',
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result: EditDocumentDialogResult) => {
      if (result?.action === 'save' && result.data) {
        this.updateDocument(document, result.data);
      }
    });
  }

  private updateDocument(originalDocument: GradeTable, updatedData: Partial<GradeDocument>): void {
    if (!this.currentGradeRevision?.id) {
      this.showErrorToast('No revision selected. Cannot update document.');
      return;
    }

    // Update the document via API
    const updateRequest = {
      authors: updatedData.authors,
      year: updatedData.year,
      study_type: updatedData.study_type,
      main_outcome: updatedData.main_outcome,
      precision: updatedData.precision,
      consistency: updatedData.consistency,
      risk_of_bias: updatedData.risk_of_bias,
      grade_quality: updatedData.grade_quality
    };

    const documentId = originalDocument.id || 0;
    const updateSubscription = this.gradeService.updateDocument(documentId, updateRequest).subscribe({
      next: (updatedDocument: GradeDocument) => {
        // Update the local data source
        const index = this.biblioSearchDataSource.data.findIndex(doc => doc.id === originalDocument.id);
        if (index !== -1) {
          const updatedTableRow: GradeTable = {
            ...originalDocument,
            authors: updatedDocument.authors || originalDocument.authors,
            year: updatedDocument.year || originalDocument.year,
            studyType: updatedDocument.study_type || originalDocument.studyType,
            mainOutcome: updatedDocument.main_outcome || originalDocument.mainOutcome,
            precision: updatedDocument.precision || originalDocument.precision,
            consistency: updatedDocument.consistency || originalDocument.consistency,
            riskOfBias: updatedDocument.risk_of_bias || originalDocument.riskOfBias,
            gradeQuality: updatedDocument.grade_quality || originalDocument.gradeQuality
          };

          const newData = [...this.biblioSearchDataSource.data];
          newData[index] = updatedTableRow;
          this.biblioSearchDataSource.data = newData;
        }

        this.showSuccessToast('Document updated successfully.');
      },
      error: (error) => {
        console.error('Error updating document:', error);
        this.showErrorToast('Failed to update document. Please try again.');
      }
    });

    this.subscriptions.push(updateSubscription);
  }

  /**
   * Add a new keyword to the chip list
   */
  addKeyword(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      // Add keyword if it doesn't already exist
      if (!this.keywordsForChipList.includes(value)) {
        this.keywordsForChipList.push(value);
      }
    }

    // Clear the input value
    event.chipInput!.clear();
  }

  /**
   * Remove a keyword from the chip list
   */
  removeKeyword(keyword: string): void {
    const index = this.keywordsForChipList.indexOf(keyword);

    if (index >= 0) {
      this.keywordsForChipList.splice(index, 1);
    }
  }
}

